'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = absolutesToAbsolute;
function absolutesToAbsolute(currentLocation, targetLocation) {
  var cr = currentLocation.split('/');
  var tr = targetLocation.split('/');

  // remove any shared values
  while (tr[0] && cr[0] === tr[0]) {
    cr.shift();
    tr.shift();
  }

  if (cr.length < 2) {
    return './' + tr.join('/');
  }

  cr.shift();

  return cr.map(function () {
    return '..';
  }).join('/') + '/' + tr.join('/');
}